/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Specialty = {
  properties: {
    name: {
      type: 'string',
      isRequired: true,
    },
    type: {
      type: 'ProfessionalSpecialtyType',
      isRequired: true,
    },
  },
} as const;
